// ============================================================================
// Error Messages for Subscription Management Epic
// ============================================================================

/**
 * Error messages for Subscription Management Epic.
 * Maps API error responses (401, 400, 409, 500) to user-facing messages.
 */
export const SUBSCRIPTION_ERROR_MESSAGES = {
  // Validation / generic
  REQUIRED: 'To pole jest wymagane',
  PLAN_NAME_ALREADY_EXISTS: 'Plan subskrypcji o tej nazwie już istnieje',
  PRICE_TOO_BIG: 'Wprowadź prawidłową cenę',
  INVALID_BASE_PRICE: 'Wprowadź prawidłową cenę',

  // API errors (match backend)
  UNAUTHORIZED: 'Missing authorization context',
  VALIDATION_ERROR: 'Invalid JSON in request body',
  ZOD_VALIDATION: 'Nieprawidłowe dane. Sprawdź formularz.',
  CONFLICT_PLAN_NAME: 'Plan subskrypcji o tej nazwie już istnieje',
  INTERNAL_SERVER_ERROR: 'Internal server error',

  // Client-side
  DEFAULT_ERROR: 'Wystąpił błąd podczas tworzenia planu subskrypcji',
  NETWORK_ERROR: 'Coś poszło nie tak. Spróbuj ponownie.',
  NO_INTERNET_ERROR:
    'Brak połączenia z internetem. Sprawdź połączenie i spróbuj ponownie.',
  UNEXPECTED_ERROR: 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.',
  VIEW_PLAN_DEFAULT_ERROR:
    'Wystąpił błąd podczas pobierania danych planu subskrypcji',
  EDIT_PLAN_DEFAULT_ERROR:
    'Wystąpił błąd podczas aktualizacji planu subskrypcji',
  NO_PERMISSION_TOOLTIP: 'Nie masz uprawnień do wykonania tej akcji',
  CANNOT_DEACTIVATE_ACTIVE_CLIENTS_TOOLTIP: (count: number) =>
    `You cannot deactivate this plan while it has ${count} active clients.`,
} as const;
